var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "goback-bar-cla" }, [
        _c("div", { staticClass: "goBack", on: { click: _vm.goBack } }, [
          _c("i", { staticClass: "goback-icon-cla" }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("developer.goback")))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "appInfo_box" }, [
        _c("div", { staticClass: "logo-box-cla" }, [
          _c(
            "div",
            { staticClass: "logo_left_cla" },
            [
              _c(
                "el-upload",
                {
                  staticClass: "avatar-uploader",
                  attrs: {
                    action: "/apiv1/pioneer/app/uploadAppIcon",
                    "show-file-list": false,
                    data: _vm.data,
                    "on-success": _vm.handleAvatarSuccess,
                    "on-error": _vm.uploadError,
                    "before-upload": _vm.beforeAvatarUpload
                  }
                },
                [
                  _vm.appLog
                    ? _c("img", {
                        staticClass: "avatar",
                        attrs: { src: _vm.appLog }
                      })
                    : _c("i", {
                        staticClass: "el-icon-plus avatar-uploader-icon"
                      }),
                  _vm._v(" "),
                  _c("div", { staticClass: "edit-header-img-cla" }, [
                    _c("i", { staticClass: "el-icon-edit" })
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "logo_right_cla" }, [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "space-between"
                }
              },
              [
                _c("span", { staticClass: "app-name_cla" }, [
                  _vm._v(_vm._s(_vm.appInfo.name))
                ]),
                _vm._v(" "),
                _c("i", {
                  staticClass: "el-icon-edit app_edit_cla",
                  on: { click: _vm.editApp }
                })
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "logo-app-des" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("developer.appDes")) +
                  "： " +
                  _vm._s(_vm.appInfo.des) +
                  "\n        "
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "appKey_box" }, [
          _c("p", [_vm._v("AppKey")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.appInfo.appKey))])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "appSecret_box" }, [
          _c("div", { staticStyle: { width: "80%" } }, [
            _c("p", [_vm._v("AppSecret")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.appSecret))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "appSecret-left" }, [
            _c("i", {
              staticClass: "show-app-secret",
              class: _vm.isShow
                ? "iconfont zk-icon-kejian"
                : "iconfont zk-icon-bukejian",
              attrs: {
                title: _vm.isShow
                  ? _vm.$t("developer.visiable")
                  : _vm.$t("developer.disvisible")
              },
              on: { click: _vm.showAppSecret }
            }),
            _vm._v(" "),
            _c("i", {
              staticClass: "reset-btn-cla zk-icon-lixian",
              staticStyle: { color: "#4db22f" },
              attrs: { title: _vm.$t("developer.reset") },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.resetAppSecret($event)
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "endPoint_box" }, [
          _c("p", [_vm._v("EndPoint")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.isEmpty(_vm.endPoint)))])
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("license.titles"),
            visible: _vm.dialogVisible,
            width: "35%",
            "before-close": _vm.closeCodeDailog
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "codeForm",
              attrs: {
                model: _vm.codeForm,
                rules: _vm.rules,
                "label-width": "120px"
              }
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _vm.isEmail
                    ? _c(
                        "el-col",
                        { attrs: { span: 18 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("developer.mail") } },
                            [
                              _c("el-input", {
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.email,
                                  callback: function($$v) {
                                    _vm.email = $$v
                                  },
                                  expression: "email"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _c(
                        "el-col",
                        { attrs: { span: 18 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("developer.phone") } },
                            [
                              _c("el-input", {
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.phone,
                                  callback: function($$v) {
                                    _vm.phone = $$v
                                  },
                                  expression: "phone"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", disabled: !_vm.isChange },
                          on: { click: _vm.changeWay }
                        },
                        [_vm._v(_vm._s(_vm.$t("developer.changeWay")))]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 18 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("developer.code"),
                            prop: "code"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: _vm.$t("common.emailCodes") },
                            model: {
                              value: _vm.codeForm.code,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.codeForm,
                                  "code",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "codeForm.code"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c("timing", {
                        ref: "timing",
                        attrs: { status: _vm.status },
                        on: { toGetCode: _vm.toGetCode }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeCodeDailog } }, [
                _vm._v("\n        " + _vm._s(_vm.$t("common.cancel")))
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitCode } },
                [_vm._v("\n        " + _vm._s(_vm.$t("common.confirm")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("appInfoDailog", {
        ref: "appInfoDailog",
        attrs: { title: _vm.title, appForm: _vm.appForm },
        on: { enterApp: _vm.enterApp }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "appDeatil" },
        [
          _c(
            "el-tabs",
            {
              model: {
                value: _vm.activeName,
                callback: function($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName"
              }
            },
            [
              _vm.hasPermission("c6f91d4dd2f343a9ba6c21095aabafd6")
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: this.$t("developer.dashboard"),
                        name: "first"
                      }
                    },
                    [
                      _vm.activeName === "first"
                        ? _c("dashboard", {
                            attrs: { appInfo: _vm.appInfo },
                            on: {
                              toDataTransferStation: function($event) {
                                _vm.activeName = "fourth"
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("342e40cc4bc4451095bfa7d442e0eee2")
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("developer.newsSub"),
                        name: "second"
                      }
                    },
                    [
                      _vm.activeName === "second"
                        ? _c("appMessage", { attrs: { appInfo: _vm.appInfo } })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("3fb6e4dd87e243db809ad69ecf069c50")
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: this.$t("developer.pushSetting"),
                        name: "third"
                      }
                    },
                    [
                      _vm.activeName === "third"
                        ? _c("appSetting", { attrs: { appInfo: _vm.appInfo } })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("6edd9ff63ccf42b08b09271d0dcfd706")
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: this.$t("developer.dataTransferStation"),
                        name: "fourth"
                      }
                    },
                    [
                      _vm.activeName === "fourth"
                        ? _c("pushDataList", {
                            attrs: { appInfo: _vm.appInfo }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("2e8b1161168e4312be784c31c6d7ad3e")
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: this.$t("developer.apiLog"),
                        name: "Fifth"
                      }
                    },
                    [
                      _vm.activeName === "Fifth"
                        ? _c("ApiLog", {
                            attrs: { appLog: true, appInfo: _vm.appInfo }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("79b6d7ab284d4a809ef60e03810adb46")
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: this.$t("appSetting.deviceCommand"),
                        name: "Sixth"
                      }
                    },
                    [
                      _vm.activeName === "Sixth"
                        ? _c("DeviceCommand", { attrs: { appKey: _vm.appKey } })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("ddd645dfa41549e386e5bebdfa58fd55")
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("developer.appFnSetting"),
                        name: "seventh"
                      }
                    },
                    [
                      _vm.activeName === "seventh"
                        ? _c("AppFnSetting", {
                            attrs: { appInfo: _vm.appInfo },
                            on: { updateAppInfo: _vm.getAppInfo }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("83670c102686445cb6cb913292c8684e")
                ? _c(
                    "el-tab-pane",
                    { attrs: { label: "推送日志", name: "eight" } },
                    [
                      _vm.activeName === "eight"
                        ? _c("pushLog", {
                            attrs: { isTab: true, appKey: _vm.appKey }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ab939b96", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab939b96","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/developer/appSetting.vue
// module id = null
// module chunks = 